import {
  GET_FEED_LOADING,
  GET_FEED_SUCCESS,
  GET_FEED_FAILED,
  GET_FEED_REMOVE,
} from "../types";

export interface FeedItem {
  note: string;
  planTemplateId: number;
  hasAttachment?: boolean;
}

interface FeedState {
  loading: boolean;
  error: string | null;
  status: number | null;
  data: FeedItem[];
  pageNumber: number;
  pageSize: number;
  total?: number;
}

const initialState: FeedState = {
  loading: false,
  error: null,
  status: null,
  data: [],
  pageNumber: 1,
  pageSize: 10,
};

type Action = {
  type: string;
  loading?: boolean;
  payload?: any;
  status?: number;
  error?: string | null;
  pageNumber?: number;
  pageSize?: number;
  total?: number;
};

export const feedReducer = (
  state = initialState,
  action: Action
): FeedState => {
  switch (action.type) {
    case GET_FEED_LOADING:
      return { ...state, loading: action.loading ?? true, error: null };
    case GET_FEED_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload?.content ?? action.payload ?? [],
        status: action.status ?? 200,
        pageNumber: action.pageNumber ?? state.pageNumber,
        pageSize: action.pageSize ?? state.pageSize,
        total: action.total ?? state.total,
        error: null,
      };
    case GET_FEED_FAILED:
      return {
        ...state,
        loading: false,
        data: [],
        error: action.error ?? "Failed to load feed",
        status: action.status ?? null,
      };
    case GET_FEED_REMOVE:
      return initialState;
    default:
      return state;
  }
};
